import { useEffect } from "react";
import { toast } from "sonner";
import { LEAVE_TAB_CONFIRM_MESSAGE } from "../../utils/activeTabSession";

const KEY = "ebusso_unload_logout_notice_v1";
const MAX_AGE_MS = 180000;

export default function UnloadLogoutNotice() {
  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return;
      localStorage.removeItem(KEY);
      const data = JSON.parse(raw);
      const t = typeof data?.t === "number" ? data.t : 0;
      if (!t || Date.now() - t > MAX_AGE_MS) return;
      if (data.reason === "no_api_url") {
        toast.warning("Tab close sign-out did not run", {
          description:
            "The API base URL is missing for this site host (see Config.js or set REACT_APP_API_URL). Use Sign out from the menu to log off.",
          duration: 16000,
        });
      } else {
        toast.info(LEAVE_TAB_CONFIRM_MESSAGE, {
          description:
            "A sign-out request was sent when your last tab closed. Browsers cannot confirm the server finished. Use Sign out from the menu if you need to be sure.",
          duration: 14000,
        });
      }
    } catch (_) {}
  }, []);
  return null;
}
